import * as React from "react";
import Section from "../../../../ui-library/section/section";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import Row from "../../../../ui-library/column-system/row";
import Column from "../../../../ui-library/column-system/column";
import ImageCard from "../../../../ui-library/image-card/image-card";
import { EventCategory } from "../../../../../utils/analytics";
import { RESOURCES } from "./resources-data";

const Resources: React.FC = () => {
  return (
    <div>
      <Section>
        <CardHeading>Featured projects</CardHeading>

        <Row>
          {RESOURCES.map(({ name, description, imageUrl, url }) => (
            <Column key={name} spanLg={4}>
              <ImageCard
                title={name}
                description={description}
                url={url}
                imageUrl={imageUrl}
                ctaTitle="Explore site"
                isExternal={true}
                analytics={{
                  category: EventCategory.CovidResourcesPage,
                  action: "Click - COVID-19 resource link",
                  label: name,
                }}
              />
            </Column>
          ))}
        </Row>
      </Section>
    </div>
  );
};

export default Resources;
